import * as popups from "./popups";

export const common = {
    ...popups
}